// extracted by mini-css-extract-plugin
export default {"thumbnail":"Item_thumbnail__Kr7YD"};